import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { OnboardingDocumentsDetailsWebPage } from 'commons/types/DTO/bank/applications/onboardingDocuments'
import { Request } from 'commons/utils/request'

export const ONBOARDING_DOCUMENT_DETAILS_KEY = 'onboardingDocumentDetails'

export const onboardingDocumentDetailsQueryOptions = (params: {
  id: number
  historyPage?: number
  historySize?: number
}) =>
  queryOptions<OnboardingDocumentsDetailsWebPage>({
    queryKey: [ONBOARDING_DOCUMENT_DETAILS_KEY, params],
    queryFn: async () =>
      await Request.post(Request.urls.bank.onboardingDocumentsDetailsWebPage, {
        id: params.id,
        historyPage: params.historyPage,
        historySize: params.historySize
      }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
